import Eye from './Eye'
import EyeClosed from './EyeClosed'

export default {
  Eye,
  EyeClosed,
}
